import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { initAnalyticsIfConsented, trackPageview } from "../lib/analytics";

/**
 * Fires a GA4 pageview on every client-side route change. Mounted once inside
 * <BrowserRouter>. No-op unless the user has accepted cookies AND a GA ID is
 * configured via REACT_APP_GA4_MEASUREMENT_ID.
 */
export default function AnalyticsTracker() {
  const { pathname, search } = useLocation();

  useEffect(() => {
    initAnalyticsIfConsented();
  }, []);

  useEffect(() => {
    trackPageview(pathname + search);
  }, [pathname, search]);

  return null;
}
